import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { lighten, darken, rgba } from 'polished';

const lightenAmount = {
    hover: 0.1,
    active: 0.075
};

export const Wrapper = styled.label`
    display: block;
    position: relative;
    margin: 0 auto;
    max-width: 6rem;
`;

export const Inner = styled.div<{ heightPercentage?: number, hasError?: boolean }>`
    position: relative;
    overflow: hidden;
    height: 0;
    box-shadow: 0px 1px 4px 0px ${({ theme }) => rgba(theme.colors.black, 0.1)};
    width: 100%;
    border-radius: 50%;
    background-color: ${({ hasError, theme }) => hasError ? lighten(.35, theme.colors.error) : theme.colors.white};
    ${({ heightPercentage }) =>
        heightPercentage &&
        css`
        padding-bottom: ${heightPercentage}%;
    `}
`;

export const NoImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    user-select: none;

    img {
        width: 100%;
        height: auto;
        max-width: 4rem;
    }
`;

export const UploadIcon = styled.a`
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 2;
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.secondary};

    &:hover {
        background-color: ${({ theme }) => lighten(lightenAmount.hover, theme.colors.secondary)};
    }

    &:active {
        background-color: ${({ theme }) => darken(lightenAmount.active, theme.colors.secondary)};
    }
    img {
        width: 100%;
        height: auto;
        max-width: 4rem;
    }
`;

export const Image = styled.div<{ image?: string; }>`
    position: absolute;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: 100%;

    ${({ image }) =>
        image != null &&
        css`
        background-image: url(${image});
    `}
`;

export const Input = styled.input`
    opacity: 0;
    width: 0;
    height: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
`;

export const Label = styled.div`
    cursor: pointer;
`;
